import {
  getLocalPhoneNumber as getLocalPhoneNumberFromRedux,
  getLocalSelectedCountry as getLocalSelectedCountryFromRedux
} from '@selectors/auth';
import useLoginStore from '@stores/login/loginStore';
import {
  getLocalPhoneNumber,
  getLocalSelectedCountry
} from '@stores/selectors/login';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useLocalPhoneNumber = () => {
  const localPhoneNumber = useLoginStore(getLocalPhoneNumber);
  const localSelectedCountry = useLoginStore(getLocalSelectedCountry);
  const localSelectedCountryFromRedux = useSelector(
    getLocalSelectedCountryFromRedux
  );
  const localPhoneNumberFromRedux = useSelector(getLocalPhoneNumberFromRedux);
  return useMemo(() => {
    if (localSelectedCountryFromRedux || localPhoneNumberFromRedux)
      return {
        localSelectedCountry: localSelectedCountryFromRedux,
        localPhoneNumber: localPhoneNumberFromRedux
      };

    if (localPhoneNumber || localSelectedCountry)
      return {
        localSelectedCountry,
        localPhoneNumber
      };

    return {};
  }, [
    localPhoneNumber,
    localSelectedCountry,
    localSelectedCountryFromRedux,
    localPhoneNumberFromRedux
  ]);
};

export default useLocalPhoneNumber;
